<!-- Loading Skeleton -->
<div *ngIf="isLoading" class="chat-skeleton" @fadeInUp>
  <div class="container">
    <!-- Header Skeleton -->
    <div class="skeleton-header">
      <div class="skeleton-profile">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-name"></div>
      </div>
    </div>

    <!-- Messages Skeleton -->
    <div class="skeleton-messages">
      <div class="skeleton-message received"></div>
      <div class="skeleton-message sent"></div>
      <div class="skeleton-message received"></div>
      <div class="skeleton-message sent"></div>
    </div>

    <!-- Input Skeleton -->
    <div class="skeleton-input">
      <div class="skeleton-input-field"></div>
      <div class="skeleton-send-button"></div>
    </div>
  </div>
</div>

<!-- Main Chat Interface -->
<div *ngIf="!isLoading" class="chat-container" @fadeInUp>
  <div class="container">

    <!-- Header Section -->
    <div class="chat-header" @fadeInUp>
      <div class="header-content">
        <div class="profile-section">
          <div class="profile-avatar">
            <img [src]="'icons/table-profile-pic.svg'" alt="Table Profile" class="profile-pic">
            <div class="online-indicator"></div>
          </div>
          <div class="profile-info">
            <h3 class="table-name">{{ orderDetails?.barcode_details?.name || 'Loading...' }}</h3>
            <p class="table-status">
              <i class="fas fa-circle status-dot"></i>
              <span>Active Chat</span>
            </p>
          </div>
        </div>
        <div class="chat-actions">
          <button class="action-btn" type="button">
            <i class="fas fa-ellipsis-v"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Chat Messages -->
    <div class="chat-body" #chatBody [class.loading]="isChatLoading">

      <!-- Chat Loading -->
      <div *ngIf="isChatLoading" class="chat-loading">
        <div class="loading-spinner"></div>
        <p>Loading conversation...</p>
      </div>

      <!-- Messages -->
      <div class="messages-container" *ngIf="!isChatLoading" @staggerMessages>
        <div
          *ngFor="let message of chatHistory; trackBy: trackByMessage"
          class="message-wrapper"
          [ngClass]="{
            'sent': message.sender_type === 'waiter',
            'received': message.sender_type === 'table'
          }"
          [@messageSlide]="{value: '', params: {direction: getMessageDirection(message.sender_type)}}">

          <div class="message-bubble">
            <div class="message-content">
              <p class="message-text">{{ message.body }}</p>
              <div class="message-meta">
                <span class="message-time">{{ formatTimestamp(message.timestamp) }}</span>
                <div class="message-status" *ngIf="message.sender_type === 'waiter'">
                  <i class="fas fa-clock" *ngIf="message.sending"></i>
                  <i class="fas fa-check" *ngIf="message.sent"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isChatLoading && chatHistory.length === 0" class="empty-chat" @fadeInUp>
        <div class="empty-chat-content">
          <div class="empty-chat-icon">
            <i class="fas fa-comments"></i>
          </div>
          <h4>Start the conversation</h4>
          <p>Send a message to {{ orderDetails?.barcode_details?.name }}</p>
        </div>
      </div>
    </div>

    <!-- Message Input -->
    <div class="message-input-section" @fadeInUp>
      <div class="input-container">
        <div class="input-wrapper">
          <input
            type="text"
            [(ngModel)]="newMessage"
            (keyup.enter)="sendChatMessage()"
            [disabled]="isSendingMessage"
            placeholder="Type your message..."
            class="message-input"
            maxlength="500">
          <div class="input-actions">
            <button
              class="send-button"
              (click)="sendChatMessage()"
              [disabled]="!newMessage.trim() || isSendingMessage"
              [class.sending]="isSendingMessage"
              type="button">
              <div class="send-spinner" *ngIf="isSendingMessage"></div>
              <i class="fas fa-paper-plane" *ngIf="!isSendingMessage"></i>
            </button>
          </div>
        </div>
        <div class="character-count" *ngIf="newMessage.length > 400">
          {{ newMessage.length }}/500
        </div>
      </div>
    </div>

  </div>
</div>
